import { getSessionToken } from './auth';

interface PhotoMetadata {
  date: string;
  category: string;
  id: string;
}

export const uploadToBlob = async (file: File, metadata?: PhotoMetadata): Promise<string> => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    
    // Add metadata for structured filename
    if (metadata) {
      formData.append('date', metadata.date);
      formData.append('category', metadata.category);
      formData.append('photoId', metadata.id);
    }

    const sessionToken = getSessionToken();
    const response = await fetch('/api/blob-upload', {
      method: 'POST',
      headers: {
        'X-Session-Token': sessionToken || '',
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Blob upload failed: ${response.statusText}`);
    }

    const { url } = await response.json();
    console.log('Blob upload successful:', url);
    return url;
  } catch (error) {
    console.warn('Blob upload failed, falling back to base64:', error);
    return convertToBase64(file);
  }
};

const convertToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result);
      } else {
        reject(new Error('Failed to convert file to base64'));
      }
    };
    reader.onerror = () => reject(new Error('FileReader error'));
    reader.readAsDataURL(file);
  });
};

export const deleteFromBlob = async (url: string): Promise<void> => {
  try {
    if (url.startsWith('data:')) {
      return;
    }

    const sessionToken = getSessionToken();
    const response = await fetch('/api/photos', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Session-Token': sessionToken || '',
      },
      body: JSON.stringify({ url }),
    });

    if (!response.ok) {
      console.warn(`Failed to delete blob: ${response.statusText}`);
    }
  } catch (error) {
    console.warn('Error deleting blob:', error);
  }
};